import {
  Component,
  Input,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger
} from '@angular/material/autocomplete';
import { Observable } from 'rxjs';

@Component({
  // TODO: remove all usages of the previous app-autocomplete and rename to app-autocomplete
  // TODO: clean up app-autocomplete-3 from style files
  selector: 'app-autocomplete-3',
  templateUrl: './autocomplete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppAutocompleteComponent<T> {
  @Input('ctx') private readonly _ctx: AppAutocompleteComponent.IContext<T>;

  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;

  get hint() {
    return this._ctx.hint;
  }

  get placeholder() {
    return this._ctx.placeholder;
  }

  get control() {
    return this._ctx.control;
  }

  get options$() {
    return this._ctx.options$;
  }

  onSelect(event: MatAutocompleteSelectedEvent): void {
    this._ctx.onSelect && this._ctx.onSelect(event.option.value);
  }

  optionTitle = (option: T) => {
    return this._ctx.optionTitle(option);
  };
}

export namespace AppAutocompleteComponent {
  export interface IContext<T> {
    readonly control: FormControl;
    readonly options$: Observable<T[]>;
    readonly optionTitle: (option: T) => string;
    readonly placeholder: string;
    readonly hint?: string;
    readonly onSelect?: (option: T) => void;
  }
}
